import { useState, useEffect } from 'react'

// Deadline: Wednesday Feb 25, 2026 at 11:59pm EST (UTC-5)
const DEADLINE = new Date('2026-02-26T04:59:00Z')

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft())
  const [isExpired, setIsExpired] = useState(
    () => Date.now() >= DEADLINE.getTime(),
  )

  useEffect(() => {
    const tick = () => {
      const tl = getTimeLeft()
      setTimeLeft(tl)
      setIsExpired(Date.now() >= DEADLINE.getTime())
    }
    const id = setInterval(tick, 1000)
    return () => clearInterval(id)
  }, [])

  return { timeLeft, isExpired }
}

function getTimeLeft() {
  const diff = DEADLINE.getTime() - Date.now()
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 }
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((diff % (1000 * 60)) / 1000)
  return { days, hours, minutes, seconds }
}
